import { compare } from './Compare';
function toIndices(values) {
    return Array.from(values, (_, i) => i);
}
export function toSortedIndicesUsing(values, comparator) {
    return toIndices(values).sort((a, b) => {
        return comparator(values[a], values[b]);
    });
}
export function toSortedIndices(values, order) {
    if (order !== 0) {
        return toSortedIndicesUsing(values, (a, b) => {
            return compare(a, b) * order;
        });
    }
    return toIndices(values);
}
